let navigate;

export const setNavigate = (navFn) => {
  navigate = navFn;
};

export const goTo = (path, options = {}) => {
  if (navigate) {
    navigate(path, options);
  } else {
    console.error("Navigation function is not set.");
  }
};